module.exports = __webpack_public_path__ + "img/space.0cc3686e.jpg";